<template>
  <v-card
    :class="currentlyViewedChallenge.isFacilitator || currentlyViewedChallenge.isCofacilitator ? 'mx-auto fact drag-drop' : 'mx-auto fact'"
    width="250"
    elevation="20"
    :data-thoughtid=fact.uuid
    data-thoughttype="Fact"
    light>
      <v-container fill-height>
        <v-row justify="center">
          {{ fact.content }}
        </v-row>
      </v-container>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Fact',
  props: ['fact'],
  data: () => ({
    windowHeight: window.innerHeight
  }),
  computed: {
    ...mapState({
      currentlyViewedChallenge: state => state.challenge.currentlyViewedChallenge
    }),
    height: function () {
      return this.windowHeight - 60
    }
  },
  created () {
    window.addEventListener('resize', () => {
      this.windowHeight = window.innerHeight
    })
  },

  destroyed () {
    window.removeEventListener('resize', () => {
      this.windowHeight = window.innerHeight
    })
  }
}
</script>

<style lang="sass" scoped>
  .fact
    margin: 1em
    text-align: center
    touch-action: none
    word-break: break-word
</style>
